import React from 'react';
import styles from '../../styles/components/survey-stack/SurveyButton.module.css';

export interface SurveyButtonData {
  text: string;
  imageSource: string;
  isDisabled?: boolean;
  onClick: () => void;
}
export const SurveyButton: React.FC<SurveyButtonData> = props => {
  return (
    <div
      className={props.isDisabled ? styles.disabledButton : styles.button}
      onClick={props.onClick}
    >
      <img
        className={styles.image}
        src={props.imageSource}
        alt={'survey button'}
      />
      <span className={styles.text}>{props.text}</span>
    </div>
  );
};
